
// Helper function to create SEO-friendly slugs
export function createSlug(text: string): string {
  if (!text) return '';
  
  return text
    .toLowerCase()
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^\w\s-]/g, ' ')
    .replace(/\s+/g, ' ')
    .replace(/\s/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '')
    .substring(0, 60);
}

// Helper function to create place type slugs
export function createPlaceTypeSlug(placeType: string): string {
  if (!placeType) return 'place';
  
  const typeMapping: { [key: string]: string } = {
    'restaurant': 'restaurants',
    'hotel': 'hotels',
    'attraction': 'attractions',
    'museum': 'museums',
    'park': 'parks',
    'beach': 'beaches',
    'shopping': 'shopping',
    'nightlife': 'nightlife',
    'cafe': 'cafes',
    'bar': 'bars',
    'activity': 'activities',
    'tour': 'tours',
    'festival': 'festivals',
    'event': 'events'
  };
  
  const normalizedType = placeType.toLowerCase().trim();
  return typeMapping[normalizedType] || createSlug(placeType);
}

// Create SEO-friendly place URL
export function createPlaceUrl(place: {
  id: string;
  name: string;
  city: string;
  country: string;
  place_type?: string;
}): string {
  const countrySlug = createSlug(place.country);
  const citySlug = createSlug(place.city);
  const placeTypeSlug = createPlaceTypeSlug(place.place_type || 'attraction');
  const nameSlug = createSlug(place.name);
  
  return `/places/${countrySlug}/${citySlug}/${placeTypeSlug}/${nameSlug}/${place.id}`;
}
